import React from 'react'
import {changeSelectedState} from '../actions/actions'
import HardestHitStore from '../stores/hardest-hit-store'
import {dispatch} from 'fluxury'

const noActiveProgramText = `Not currently accepting new applicants. Programs change frequently, so check the state site for updates and other local resources.`

var Programs = React.createClass ({

  renderProgramList: function() {
    var {currentState}  = this.props;

    var programList = this.props.programs.map(function(program, i) {
      var isActive = HardestHitStore.isProgramActive(currentState, program.key)

      return (
        <li key={"program_" + program.key}>
          <div className="row">
            <div className="col-md-1 icon">
              <i className={"fa fa-2x " + (isActive ? "fa-check-circle text-success" : "fa-ban text-danger") } />
            </div>
            <div className="col-md-11">
              <p className={"font-weight-bold program-heading " + (isActive ? "active" : "text-muted")}>{program.name}</p>
              <p className={"program-content " + (isActive ? "active" : "text-muted")}>{program.description}</p>
            </div>
          </div>

        </li>
      )
    })

    return programList;
  },

  render:function() {

    return (
      <div>
        <div classname="program-list">
          <div className="h4 mb-4">
            Available Programs
          </div>

          <div>
            { this.props.currentState === "" ?
              <a href={HardestHitStore.getStateURL(this.props.currentState)} target="_blank" className="btn btn-primary btn-block btnSelectState rounded-ends disabled" id="selectStateButton" aria-disabled="true">
                  Go To {HardestHitStore.getStateName(this.props.currentState)} HHF Site
              </a>
            :
              <a href={HardestHitStore.getStateURL(this.props.currentState)} target="_blank" className="btn btn-primary btn-block btnSelectState rounded-ends" id="selectStateButton">
                  Go To {HardestHitStore.getStateName(this.props.currentState)} HHF Site
              </a>
            }
          </div>


        </div>

        <div>
          <p className="text-danger">
            { this.props.currentState !== '' && !HardestHitStore.hasActiveProgram(this.props.currentState) ? noActiveProgramText : '' }
          </p>
          <ul className="list-unstyled pt-4">
            { this.renderProgramList() }
          </ul>
        </div>
      </div>
    )
  }

});

module.exports = Programs;



// WEBPACK FOOTER //
// ./src/components/programs.js